module.exports = __webpack_public_path__ + "media/images/new_landing/hp/zuzana-zahorova-9be67a7f2fbab3b5683763e2838c7830.png";